import { render, staticRenderFns } from "./Tournaments-Single.vue?vue&type=template&id=ddc419f2&scoped=true"
import script from "./Tournaments-Single.js?vue&type=script&lang=js&external"
export * from "./Tournaments-Single.js?vue&type=script&lang=js&external"
import style0 from "./Tournaments-Single.vue?vue&type=style&index=0&id=ddc419f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc419f2",
  null
  
)

export default component.exports